import { render, staticRenderFns } from "./RecipientList.vue?vue&type=template&id=3d620858&scoped=true"
import script from "./RecipientList.vue?vue&type=script&lang=js"
export * from "./RecipientList.vue?vue&type=script&lang=js"
import style0 from "./RecipientList.vue?vue&type=style&index=0&id=3d620858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d620858",
  null
  
)

export default component.exports